export interface PodcastEpisode {
  id: string;
  guestName: string;
  episodeTitle: string;
  quote: string;
  youtubeUrl: string;
  youtubeVideoId: string;
  thumbnailUrl: string;
  category: string;
  isRecent?: boolean;
  views?: string;
}

export const INITIAL_EPISODES: PodcastEpisode[] = [
  {
    id: "ep-top-1",
    guestName: "Charlotte Taylor",
    episodeTitle: "Love-Bombed By My Ex-Husband | Ep. 19 w/ Charlotte Taylor",
    quote:
      "A raw, eye-opening story of being love-bombed, emotional manipulation, and how God restored her self-worth.",
    youtubeUrl: "https://www.youtube.com/watch?v=vmtLdHDA_UE",
    youtubeVideoId: "vmtLdHDA_UE",
    thumbnailUrl: "https://i.ytimg.com/vi/vmtLdHDA_UE/hqdefault.jpg",
    category: "Marriage & Family",
    views: "109K views",
    isRecent: true,
  },
  {
    id: "ep-top-2",
    guestName: "Tori Bishop",
    episodeTitle:
      "My Husband Broke Up With Me Through An Email 💔 | Tori Bishop",
    quote:
      "The unexpected heartbreak of an email divorce and how she rebuilt her faith from ground zero.",
    youtubeUrl: "https://www.youtube.com/watch?v=YKMaeEZ93gU",
    youtubeVideoId: "YKMaeEZ93gU",
    thumbnailUrl: "https://i.ytimg.com/vi/YKMaeEZ93gU/hqdefault.jpg",
    category: "Marriage & Family",
    views: "51K views",
  },
  {
    id: "ep-top-3",
    guestName: "Ash Oatis",
    episodeTitle: "From Minister To Mistress | Ep. 23 w/ Ash Oatis",
    quote:
      "A powerful story of spiritual deceit, falling into secret pain, and experiencing total redemption in Christ.",
    youtubeUrl: "https://www.youtube.com/watch?v=bFpWn40xt9w",
    youtubeVideoId: "bFpWn40xt9w",
    thumbnailUrl: "https://i.ytimg.com/vi/bFpWn40xt9w/hqdefault.jpg",
    category: "Deliverance & Freedom",
    views: "28K views",
  },
  {
    id: "ep-top-4",
    guestName: "Kèla Dixon",
    episodeTitle: "Should I Go Back To Witchcraft? 😳 | S3 EP. 3 w/ Kèla Dixon",
    quote:
      "Breaking free from occult practices and discovering the ultimate authority and peace found in Jesus.",
    youtubeUrl: "https://www.youtube.com/watch?v=A5TbLmeYgh8",
    youtubeVideoId: "A5TbLmeYgh8",
    thumbnailUrl: "https://i.ytimg.com/vi/A5TbLmeYgh8/hqdefault.jpg",
    category: "Deliverance & Freedom",
    views: "27K views",
  },
  {
    id: "ep-top-5",
    guestName: "NaKisha Henderson",
    episodeTitle: "Escaping My Ex-Husband | S3 EP 1 w/ NaKisha Henderson",
    quote:
      "Walking out of toxic cycles, breaking free from control, and stepping into the safety God prepared.",
    youtubeUrl: "https://www.youtube.com/watch?v=Hd0Y10QeMGY",
    youtubeVideoId: "Hd0Y10QeMGY",
    thumbnailUrl: "https://i.ytimg.com/vi/Hd0Y10QeMGY/hqdefault.jpg",
    category: "Deliverance & Freedom",
    views: "20K views",
  },
  {
    id: "ep-top-6",
    guestName: "Catrease Thompson",
    episodeTitle: "I Lost Everything | Ep. 33 w/ Catrease Thompson",
    quote:
      "When life stripped away every safety net, she found God as her ultimate provider and anchor.",
    youtubeUrl: "https://www.youtube.com/watch?v=LIhrS3UOWgI",
    youtubeVideoId: "LIhrS3UOWgI",
    thumbnailUrl: "https://i.ytimg.com/vi/LIhrS3UOWgI/hqdefault.jpg",
    category: "Grief & Loss",
    views: "18K views",
  },
  {
    id: "ep-top-7",
    guestName: "Jaime Norwood",
    episodeTitle:
      "Best Friend's Secret Affair w/ My Husband | w/ Jaime Norwood",
    quote:
      "Exposing betrayal in close circles and finding the strength to heal from unimaginable relational heartbreak.",
    youtubeUrl: "https://www.youtube.com/watch?v=k-TJdJTpP1A",
    youtubeVideoId: "k-TJdJTpP1A",
    thumbnailUrl: "https://i.ytimg.com/vi/k-TJdJTpP1A/hqdefault.jpg",
    category: "Marriage & Family",
    views: "16K views",
  },
  {
    id: "ep-top-8",
    guestName: "Starr Magee",
    episodeTitle: "3rd Marriage By Age 30 | Ep. 20 w/ Starr Magee",
    quote:
      "Unpacking relationship patterns, identity loss, and learning what true God-centered marriage looks like.",
    youtubeUrl: "https://www.youtube.com/watch?v=9tng3cG__ig",
    youtubeVideoId: "9tng3cG__ig",
    thumbnailUrl: "https://i.ytimg.com/vi/9tng3cG__ig/hqdefault.jpg",
    category: "Marriage & Family",
    views: "15K views",
  },
  {
    id: "ep-top-9",
    guestName: "Krystal Ben",
    episodeTitle:
      "I Married For Convenience Not Purpose 💍 | Ep. 23 w/ Krystal Ben",
    quote:
      "Why settling for convenience in relationships costs your peace, and how to surrender your love life to God.",
    youtubeUrl: "https://www.youtube.com/watch?v=XHde66pkORw",
    youtubeVideoId: "XHde66pkORw",
    thumbnailUrl: "https://i.ytimg.com/vi/XHde66pkORw/hqdefault.jpg",
    category: "Marriage & Family",
    views: "12K views",
  },
  {
    id: "ep-top-10",
    guestName: "AJ Riley",
    episodeTitle: "I Barely Escaped With My Life | S2 EP.4 w/ AJ Riley",
    quote:
      "A chilling testimony of surviving domestic abuse and witnessing God's miraculous physical and emotional protection.",
    youtubeUrl: "https://www.youtube.com/watch?v=vYS1sx9X6Pk",
    youtubeVideoId: "vYS1sx9X6Pk",
    thumbnailUrl: "https://i.ytimg.com/vi/vYS1sx9X6Pk/hqdefault.jpg",
    category: "Deliverance & Freedom",
    views: "10K views",
  },
  {
    id: "ep-top-11",
    guestName: "Ashley Sheppard",
    episodeTitle: "My Best Friend Tried To Put A Curse On Me | Ashley Sheppard",
    quote:
      "Exposing hidden spiritual battles, jealousy among close friends, and finding deliverance in Jesus.",
    youtubeUrl: "https://www.youtube.com/watch?v=CG0aJEsOvcQ",
    youtubeVideoId: "CG0aJEsOvcQ",
    thumbnailUrl: "https://i.ytimg.com/vi/CG0aJEsOvcQ/hqdefault.jpg",
    category: "Deliverance & Freedom",
    views: "7.9K views",
  },
  {
    id: "ep-top-12",
    guestName: "Jessica Singleton",
    episodeTitle: "My Ex-Husband Emptied My Bank Accounts | Jessica Singleton",
    quote:
      "Overcoming financial devastation and legal battles while trusting God to restore every stolen year.",
    youtubeUrl: "https://www.youtube.com/watch?v=vhTmMtfVbL8",
    youtubeVideoId: "vhTmMtfVbL8",
    thumbnailUrl: "https://i.ytimg.com/vi/vhTmMtfVbL8/hqdefault.jpg",
    category: "Marriage & Family",
    views: "7.8K views",
  },
  {
    id: "ep-top-13",
    guestName: "Alisha Harper Stevens",
    episodeTitle: "The Worst Call of My Life | Ep. 32 w/ Alisha Harper Stevens",
    quote:
      "Navigating sudden tragic news and learning how to worship God through deep grief and confusion.",
    youtubeUrl: "https://www.youtube.com/watch?v=tCtNuFtlFJE",
    youtubeVideoId: "tCtNuFtlFJE",
    thumbnailUrl: "https://i.ytimg.com/vi/tCtNuFtlFJE/hqdefault.jpg",
    category: "Grief & Loss",
    views: "6.9K views",
  },
  {
    id: "ep-top-14",
    guestName: "Deidra Foster",
    episodeTitle: "My Husband Died Right In Front Of Me 💔 | Deidra Foster",
    quote:
      "A tragic story of widowhood, sudden grief, and discovering that God is present even in our darkest moments.",
    youtubeUrl: "https://www.youtube.com/watch?v=qQoJIInZVzw",
    youtubeVideoId: "qQoJIInZVzw",
    thumbnailUrl: "https://i.ytimg.com/vi/qQoJIInZVzw/hqdefault.jpg",
    category: "Grief & Loss",
    views: "6.8K views",
  },
  {
    id: "ep-top-15",
    guestName: "Monique Cooks",
    episodeTitle: "The Aftermath of Being SA'd | Ep. 29 w/ Monique Cooks",
    quote:
      "Healing from sexual trauma, releasing shame, and walking into the freedom Christ promises to every daughter.",
    youtubeUrl: "https://www.youtube.com/watch?v=sNoonrE-j_A",
    youtubeVideoId: "sNoonrE-j_A",
    thumbnailUrl: "https://i.ytimg.com/vi/sNoonrE-j_A/hqdefault.jpg",
    category: "Deliverance & Freedom",
    views: "6.2K views",
  },
  {
    id: "ep-top-16",
    guestName: "Destinie Weems",
    episodeTitle: "Grieving The Loss of My Children | Ep. 22 w/ Destinie Weems",
    quote:
      "A heartbreaking testimony of child loss and holding fast to God when life makes no sense.",
    youtubeUrl: "https://www.youtube.com/watch?v=cj1Csnjquic",
    youtubeVideoId: "cj1Csnjquic",
    thumbnailUrl: "https://i.ytimg.com/vi/cj1Csnjquic/hqdefault.jpg",
    category: "Grief & Loss",
    views: "6.1K views",
  },
  {
    id: "ep-top-17",
    guestName: "Frances Payton",
    episodeTitle: "Can God Deliver Me From Homosexuality? | Frances Payton",
    quote:
      "An honest look at identity, desires, and the transforming power of God's love and truth.",
    youtubeUrl: "https://www.youtube.com/watch?v=wZdrEi-WgCI",
    youtubeVideoId: "wZdrEi-WgCI",
    thumbnailUrl: "https://i.ytimg.com/vi/wZdrEi-WgCI/hqdefault.jpg",
    category: "Deliverance & Freedom",
    views: "5.7K views",
  },
  {
    id: "ep-top-18",
    guestName: "Pastor Irene T. Magee",
    episodeTitle:
      "I Could See Every Spirit Leave My Body | Pastor Irene T. Magee",
    quote:
      "An intense testimony of spiritual warfare, inner healing, and total deliverance from past strongholds.",
    youtubeUrl: "https://www.youtube.com/watch?v=PbkUsUk0H9w",
    youtubeVideoId: "PbkUsUk0H9w",
    thumbnailUrl: "https://i.ytimg.com/vi/PbkUsUk0H9w/hqdefault.jpg",
    category: "Deliverance & Freedom",
    views: "5.1K views",
  },
  {
    id: "ep-top-19",
    guestName: "Alandria Simmons",
    episodeTitle:
      "I Was Kicked Out Of Church 😳 | S3 EP. 2 w/ Alandria Simmons",
    quote:
      "Surviving rejection in religious spaces and finding true intimacy with Jesus beyond legalism.",
    youtubeUrl: "https://www.youtube.com/watch?v=z1a9q9MAL-k",
    youtubeVideoId: "z1a9q9MAL-k",
    thumbnailUrl: "https://i.ytimg.com/vi/z1a9q9MAL-k/hqdefault.jpg",
    category: "Identity & Becoming",
    views: "4.8K views",
  },
  {
    id: "ep-top-20",
    guestName: "First Lady Sarah Jones",
    episodeTitle:
      "I Know For A Fact That God Is Real | Ep. 34 w/ First Lady Sarah Jones",
    quote:
      "Miraculous encounters, undeniable faith testimonies, and trusting God through severe trials.",
    youtubeUrl: "https://www.youtube.com/watch?v=hTtM_PsUTTA",
    youtubeVideoId: "hTtM_PsUTTA",
    thumbnailUrl: "https://i.ytimg.com/vi/hTtM_PsUTTA/hqdefault.jpg",
    category: "Identity & Becoming",
    views: "4.0K views",
  },
  {
    id: "ep-top-21",
    guestName: "Jasmine Lavender",
    episodeTitle: "Adopted At Birth | Ep. 31 w/ Jasmine Lavender",
    quote:
      "Uncovering root identity issues, adoption wounds, and discovering true belonging in God's family.",
    youtubeUrl: "https://www.youtube.com/watch?v=8B-j8B3LacA",
    youtubeVideoId: "8B-j8B3LacA",
    thumbnailUrl: "https://i.ytimg.com/vi/8B-j8B3LacA/hqdefault.jpg",
    category: "Identity & Becoming",
    views: "4.0K views",
  },
  {
    id: "ep-top-22",
    guestName: "Evan King",
    episodeTitle: "Married to a Narcissist Pt. 2 | Ep. 25 w/ Evan King",
    quote:
      "Recognizing narcissism in relationships and recovering your identity and peace after psychological abuse.",
    youtubeUrl: "https://www.youtube.com/watch?v=ykpuBaLH63E",
    youtubeVideoId: "ykpuBaLH63E",
    thumbnailUrl: "https://i.ytimg.com/vi/ykpuBaLH63E/hqdefault.jpg",
    category: "Marriage & Family",
    views: "3.1K views",
  },
  {
    id: "ep-top-23",
    guestName: "Quenetria Hill",
    episodeTitle: "I Was Angry at God | Ep. 16 w/ Quenetria Hill",
    quote:
      "Telling the raw truth about frustration with unanswered prayers and finding rest in God's sovereignty.",
    youtubeUrl: "https://www.youtube.com/watch?v=nPdH_VrDOeM",
    youtubeVideoId: "nPdH_VrDOeM",
    thumbnailUrl: "https://i.ytimg.com/vi/nPdH_VrDOeM/hqdefault.jpg",
    category: "Burnout & Rest",
    views: "2.9K views",
  },
  {
    id: "ep-top-24",
    guestName: "Doris Allen-Shed",
    episodeTitle:
      "Eddie Shed: He Put His Life On The Line | S2 EP.5 w/ Doris Allen-Shed",
    quote:
      "Honoring a legacy of sacrifice, standing strong through loss, and trusting God with family destiny.",
    youtubeUrl: "https://www.youtube.com/watch?v=74rv7kUqcvw",
    youtubeVideoId: "74rv7kUqcvw",
    thumbnailUrl: "https://i.ytimg.com/vi/74rv7kUqcvw/hqdefault.jpg",
    category: "Grief & Loss",
    views: "2.6K views",
  },
  {
    id: "ep-top-25",
    guestName: "Dr. Robbie Cade Furdge",
    episodeTitle:
      "Am I Being Punished For Serving God? | Dr. Robbie Cade Furdge",
    quote:
      "Disentangling trials from punishment and learning how God refines those he calls into leadership.",
    youtubeUrl: "https://www.youtube.com/watch?v=3Ft0T9w5Cz8",
    youtubeVideoId: "3Ft0T9w5Cz8",
    thumbnailUrl: "https://i.ytimg.com/vi/3Ft0T9w5Cz8/hqdefault.jpg",
    category: "Burnout & Rest",
    views: "2.3K views",
  },
  {
    id: "ep-top-26",
    guestName: "Maxine Tarbin",
    episodeTitle:
      "I Know The Feelings I Have Are Wrong | Ep. 27 w/ Maxine Tarbin",
    quote:
      "Surrendering unhealthy emotional attachments and aligning your heart with God's word.",
    youtubeUrl: "https://www.youtube.com/watch?v=QmsKi6iOSSA",
    youtubeVideoId: "QmsKi6iOSSA",
    thumbnailUrl: "https://i.ytimg.com/vi/QmsKi6iOSSA/hqdefault.jpg",
    category: "Identity & Becoming",
    views: "2.3K views",
  },
  {
    id: "ep-top-27",
    guestName: "Corey Crockett",
    episodeTitle: "Your Man Is Secretly Insecure 🫣 | Ep. 21 w/ Corey Crockett",
    quote:
      "Understanding male vulnerability, insecurity in relationships, and building honest spiritual partnership.",
    youtubeUrl: "https://www.youtube.com/watch?v=6aNlgMwQooI",
    youtubeVideoId: "6aNlgMwQooI",
    thumbnailUrl: "https://i.ytimg.com/vi/6aNlgMwQooI/hqdefault.jpg",
    category: "Marriage & Family",
    views: "2.1K views",
  },
  {
    id: "ep-top-28",
    guestName: "Pastor Brad Hamby",
    episodeTitle:
      "I'm Preaching Everywhere But Still Broke | Pastor Brad Hamby",
    quote:
      "Exposing the gap between public ministry success and private financial burnout and exhaustion.",
    youtubeUrl: "https://www.youtube.com/watch?v=pgmJM-dWQ_w",
    youtubeVideoId: "pgmJM-dWQ_w",
    thumbnailUrl: "https://i.ytimg.com/vi/pgmJM-dWQ_w/hqdefault.jpg",
    category: "Burnout & Rest",
    views: "2.1K views",
  },
  {
    id: "ep-top-29",
    guestName: "Janiah Todd",
    episodeTitle: "I Really Felt Lost | Ep. 17 w/ Janiah Todd",
    quote:
      "When life drains your clarity and how to find your way back to God's presence step by step.",
    youtubeUrl: "https://www.youtube.com/watch?v=4CKuB9d5bKc",
    youtubeVideoId: "4CKuB9d5bKc",
    thumbnailUrl: "https://i.ytimg.com/vi/4CKuB9d5bKc/hqdefault.jpg",
    category: "Burnout & Rest",
    views: "1.9K views",
  },
  {
    id: "ep-top-30",
    guestName: "Dr. Racheal Butler",
    episodeTitle: "Rejected Because of This 💔 | Ep. 18 w/ Dr. Racheal Butler",
    quote:
      "Overcoming rejection wounds, medical challenges, and finding your unshakeable identity in Christ.",
    youtubeUrl: "https://www.youtube.com/watch?v=HSRNWF1kKC0",
    youtubeVideoId: "HSRNWF1kKC0",
    thumbnailUrl: "https://i.ytimg.com/vi/HSRNWF1kKC0/hqdefault.jpg",
    category: "Identity & Becoming",
    views: "1.7K views",
  },
];

export const CATEGORIES = [
  "All",
  "Burnout & Rest",
  "Identity & Becoming",
  "Marriage & Family",
  "Grief & Loss",
  "Deliverance & Freedom",
];
